import * as AppPasswordConstants from '../constants';

const initialState = {
  isLoading: false,
  error: false,
  isSuccess: false
};

export function appPasswordReset(state = initialState, action) {
  switch (action.type) {
    case AppPasswordConstants.APP_PASSWORD_EDIT_SUBMIT:
      return Object.assign({}, state, {isLoading: true, error: false, isSuccess: false});
    case AppPasswordConstants.APP_PASSWORD_EDIT_FAILED:
      return Object.assign({}, state, {isLoading: false, error: true, isSuccess: false});
    case AppPasswordConstants.APP_PASSWORD_EDIT_COMPLETED:
      return Object.assign({},state, {isLoading: false, error: false, isSuccess: true});
    default:
      return state;
  }
}
